import { Chapter } from "@/models/chapter.model";
import { QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class ChaptersRest {
  baseURL = "/graphs";

  getChaptersByCourse(
    courseId: string,
    params?: QueryParams
  ): Observable<Chapter[]> {
    const url: string = `/courses/${courseId}/chapters`;
    return api.get(url, params, this.baseURL);
  }

  getChapterById(courseId: string, chapterId: string): Observable<Chapter> {
    const url: string = `/courses/${courseId}/chapters/${chapterId}`;
    return api.get(url, {}, this.baseURL);
  }

  postChapter(courseId: string, data: any): Observable<Chapter | any> {
    const url: string = `/courses/${courseId}/chapters`;
    return api.post(url, data, {}, this.baseURL);
  }

  updateChapter(
    courseId: string,
    chapterId: string,
    data: any
  ): Observable<any> {
    const url: string = `/courses/${courseId}/chapters/${chapterId}`;
    return api.put(url, data, {}, this.baseURL);
  }

  postTraditionalChapter(courseId: string, data: any): Observable<Chapter | any> {
    const url: string = `/third-party/courses/${courseId}/chapter`;
    return api.post(url, data, {}, this.baseURL);
  }
}
